import { getProductTitle } from 'libs/shopify'
import CarouselSwiper from 'modules/carousel-swiper/carousel-swiper'
import Icon from 'snippets/icon/icon'
import PlpCard from 'snippets/plp-card/plp-card'

export default function ProductCarousel({ heading, subheading, products, options, ctaText, ctaLink }) {
  const optionsDefault = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: {
      enabled: true,
      sticky: true
    },
    grabCursor: true,
    speed: 500,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    }
  }

  const currentOptions = options || optionsDefault

  return products.length > 0 && (
    <div className="overflow-hidden py-8 lg:py-14">
      <div className="container">
        <CarouselSwiper
          heading={<CarouselHeading heading={heading} subheading={subheading} />}
          items={<ProductItems products={products} />}
          className='carousel-swiper-product'
          options={currentOptions}
          navigation={true}
          customNavigation={true}
          scrollbar={false}
        />
        {ctaText && ctaLink && (
          <div className="flex justify-center">
            <a className="button-outlined mt-4 w-full md:mt-8 md:mx-auto md:w-auto" href={ctaLink} title={ctaText}>{ctaText}</a>
          </div>
        )}
      </div>
    </div>
  )
}

function CarouselHeading({ heading, subheading }) {
  return (
    <div className="flex flex-col w-full mb-6">
      <h3 className="flex justify-between items-center w-full text-2xl text-grey-1000 truncate md:text-3xl">
        {heading}
        <div className="relative flex">
          <div className="swiper-button-custom swiper-button-prev js-carousel-prev">
            <Icon name="icon-chevron-left" viewBox="0 0 20 20" className="w-5 h-5 text-grey-1000"/>
          </div>
          <div className="swiper-button-custom swiper-button-next js-carousel-next">
            <Icon name="icon-chevron-right" viewBox="0 0 20 20" className="w-5 h-5 text-grey-1000"/>
          </div>
        </div>
      </h3>
      {subheading && <p className="text-sm text-grey-700 mt-0.5 md:mt-1">{subheading}</p>}
    </div>
  )
}

function ProductItems({ products }) {
  return products.map(
    (product) =>
      product && (
        <swiper-slide className="w-[264px] md:w-1/3 lg:w-1/4">
          <PlpCard
            title={getProductTitle(product.title)}
            subtitle={product.metafields.sizes}
            handle={product.handle}
            imageUrl={[product.featuredImage]}
            price={product.price}
            originalPrice={product.compareAtPriceMin}
            tags={product.tags}
            className="flex flex-col flex-shrink-0 h-full"
            variants={product.variants}
          />
        </swiper-slide>
      )
  )
}
